var _circle, _rect, _path, _path2, _g, _g2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60.25,
    r: 60,
    fill: "#F2F4F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.875,
    y: 37.998,
    width: 56.25,
    height: 48.2538,
    rx: 2.8125,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 40.8105C31.875 39.2572 33.1342 37.998 34.6875 37.998H85.3125C86.8658 37.998 88.125 39.2572 88.125 40.8105V49.248H31.875V40.8105Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M34.6362 42.2717V40.6824H85.481V42.2717H34.6362Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 3.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_318_6661",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.125 51.1021H32.7612V53.6188H88.125V51.1021Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.125 51.1021H32.7612V53.6188H88.125V51.1021Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7612 51.1021V47.3521H29.0112V51.1021H32.7612ZM88.125 51.1021H91.875V47.3521H88.125V51.1021ZM88.125 53.6188V57.3688H91.875V53.6188H88.125ZM32.7612 53.6188H29.0112V57.3688H32.7612V53.6188ZM32.7612 54.8521H88.125V47.3521H32.7612V54.8521ZM84.375 51.1021V53.6188H91.875V51.1021H84.375ZM88.125 49.8688H32.7612V57.3688H88.125V49.8688ZM36.5112 53.6188V51.1021H29.0112V53.6188H36.5112Z",
    fill: "#1A1E23",
    mask: "url(#path-5-inside-1_318_6661)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_318_6661",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.125 82.1421H32.7612V84.8942H88.125V82.1421Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.125 82.1421H32.7612V84.8942H88.125V82.1421Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7612 82.1421V78.3921H29.0112V82.1421H32.7612ZM88.125 82.1421H91.875V78.3921H88.125V82.1421ZM88.125 84.8942V88.6442H91.875V84.8942H88.125ZM32.7612 84.8942H29.0112V88.6442H32.7612V84.8942ZM32.7612 85.8921H88.125V78.3921H32.7612V85.8921ZM84.375 82.1421V84.8942H91.875V82.1421H84.375ZM88.125 81.1442H32.7612V88.6442H88.125V81.1442ZM36.5112 84.8942V82.1421H29.0112V84.8942H36.5112Z",
    fill: "#1A1E23",
    mask: "url(#path-7-inside-2_318_6661)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 56.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 64.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 71.748,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 79.248,
    r: 1.875,
    fill: "#1A1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41.748L37.5 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41.748L45 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 41.748L52.5 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41.748L60 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 41.748L67.5 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75 41.748L75 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 41.748L82.5 34.248",
    stroke: "#1A1E23",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d62e25128c817318a9ca6b81aa251c5d.svg";
export { ForwardRef as ReactComponent };